module.exports = __webpack_public_path__ + "media/cover_800.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/cover_800.jpg
// module id = 21
// module chunks = 0